import styled from '@emotion/styled'
import { Container, Typography } from '@mui/material'
import { RecallData } from "api/delek"
import EmptyResults from "common/EmptyResults"

const Styled = {
  Recall: styled.div`
    padding: 25px 17px;
    background-color: ${(p) => p.theme.colors.paleGrey};
    border-top: solid 1.5px ${(p) => p.theme.colors.silver};
    border-bottom: solid 1.5px ${(p) => p.theme.colors.silver};
  `,
  Title: styled(Typography)`
    font-size: 16px;
    color: ${(p) => p.theme.colors.marine};
    font-weight: bold;
    margin-bottom: 13px;
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 22px;
    }
  `,
  Row: styled.div`
    font-size: 14px;
    line-height: 22px;
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 18px;
    }
  `,
  Key: styled(Typography)`
    font-size: inherit;
    display: inline;
    color: ${(p) => p.theme.colors.oceanBlue};
    &:after {
      content: ": ";
    }
  `,
  Value: styled(Typography)`
    font-size: inherit;
    display: inline;
    color: ${(p) => p.theme.colors.marine};
  `,
}

type RecallProps = {
  data: RecallData[]
}

const Recalls = ({ data }: RecallProps) => (
  <>
    {data.map((recall, i) => (
      <Styled.Recall key={i}>
        <Container>
          <Styled.Title>קריאה מס&apos; {recall.numberCol}</Styled.Title>
          <Styled.Row>
            <Styled.Key>מספר רכב</Styled.Key>
            <Styled.Value>{recall.licenseNumber}</Styled.Value>
          </Styled.Row>
          <Styled.Row>
            <Styled.Key>מספר שילדה</Styled.Key>
            <Styled.Value>{recall.chassisNumber}</Styled.Value>
          </Styled.Row>
          <Styled.Row>
            <Styled.Key>שם קצר</Styled.Key>
            <Styled.Value>{recall.shortName}</Styled.Value>
          </Styled.Row>
          <Styled.Row>
            <Styled.Key>מהות הקריאה</Styled.Key>
            <Styled.Value>{recall.description}</Styled.Value>
          </Styled.Row>
        </Container>
      </Styled.Recall>
    ))}
    {data.length === 0 && <EmptyResults />}
  </>
)

export default Recalls
